export function importJson(jsonData) {
  if (jsonData && jsonData.article) {
    // transform json object in html
    document.getElementById('hypertranscript').innerHTML = jsonToHtml(jsonData);
    document.getElementById('audio-player').currentTime = Math.round(jsonData.time);
    if (document.getElementsByClassName('active').item(0)) {
      document.getElementsByClassName('active').item(0).scrollIntoView({ block: 'center', behavior: 'smooth' });
    }
  }
}

export function jsonToHtml(jsonData) {
  // Create an empty <article> element
  const div = document.createElement('div');

  const article = document.createElement('article');

  // Create an empty <section> element
  const section = document.createElement('section');

  // Add the <section> element to the <article> element
  article.appendChild(section);

  // Get the <p> elements data from the JSON object
  const { paragraphs } = jsonData.article.section;

  // Iterate through each <p> element
  for (const paragraph of paragraphs) {
    // Create an empty <p> element
    const p = document.createElement('p');

    p.setAttribute('class', 'mb-5');

    // Add the <p> element to the <section> element
    section.appendChild(p);

    // Get the <span> elements data from the JSON object
    const { spans } = paragraph;
    // Iterate through each <span> element
    for (const span of spans) {
      const spanElement = document.createElement('span');

      // Set the "data-m" attribute value
      spanElement.setAttribute('data-m', span.m);

      // Set the "data-d" attribute value
      spanElement.setAttribute('data-d', span.d);

      // Set the class attribute value
      if (span.class && span.class.includes('active')) {
        if (span.class && span.class.includes('speaker')) {
          spanElement.setAttribute('class', 'speaker active text-[rgb(102,102,102)] font-bold bg-green-200');
        } else {
          spanElement.setAttribute('class', 'active text-[rgb(102,102,102)] bg-green-200');
        }
      } else if (span.m <= (jsonData.time * 1000)) {
        if (span.class && span.class.includes('speaker')) {
          spanElement.setAttribute('class', 'speaker text-black font-bold');
        } else {
          spanElement.setAttribute('class', 'text-black');
        }
      } else if (span.m > jsonData.time && span.m <= (jsonData.time * 1000) + 5000) {
        if (span.class && span.class.includes('speaker')) {
          spanElement.setAttribute('class', 'speaker text-[rgb(102,102,102)] font-bold bg-green-200');
        } else {
          spanElement.setAttribute('class', 'text-[rgb(102,102,102)] bg-green-200');
        }
      } else if (span.m > (jsonData.time * 1000) + 5000) {
        if (span.class && span.class.includes('speaker')) {
          spanElement.setAttribute('class', 'speaker text-[rgb(102,102,102)] font-bold cursor-pointer');
        } else {
          spanElement.setAttribute('class', 'text-[rgb(102,102,102)]');
        }
      }
      // spanElement.setAttribute('class', span.class);

      // Set the text content of the <span> element
      spanElement.textContent = span.text;

      // Add the <span> element to the <p> element
      p.appendChild(spanElement);
    }
    // for (const span of spans) {
    //     // Create an empty <span> element

    // }
  }

  div.appendChild(article);
  // Return the <article> element

  return div.innerHTML;
}

export default importJson;
